import styled from "styled-components";
import { buttonTypography, fontWeightBold, h4Regular } from "../typography/MuiTypography.style";

export const VersionTrackerModalWrapper = styled.div`
  .MuiPopper-root{
    z-index: 1;

    .notificationIcon{ 
      display: none;
    }

  }
  .form-header-right {
    .text-title {
      ${buttonTypography}
      margin-left: 4px;
    }

    &:disabled{
      padding.MuiTypography-root:hover {
        cursor: none;
        text-decoration: none;
      }
    }
    
    .version-name {
      ${h4Regular}
      ${fontWeightBold}
    }
  }
`;
